<template>
  <div class="fangyuanPage">
    <div class="pb20">
      <div v-show="showPage">
        <div>
          <div class="imgBox">
            <img :src="item.zsxx.topImg" class="zsImg1" />
          </div>
          <!-- 校验码开始 -->
          <div
            class="ewmBoxWrap"
            :style="[
              { backgroundImage: `url(${item.boxBg})` },
              { backgroundRepeat: 'no-repeat' },
              { backgroundSize: '100% 100%' },
            ]"
          >
            <div class="ewmBoxTitle ewmBoxTitle1">Year traceability</div>
            <div class="ewmBoxTitle ewmBoxTitle2">溯源白酒年份</div>

            <div class="ewmBox">
              <!--左边-->
              <div
                class="ewmLeftBox2"
                :style="{ backgroundImage: `url(${item.scanBg})` }"
              >
                <div class="ewmImgBox2">
                  <!-- <vue-qr
                    :size="80"
                    :margin="0"
                    :auto-color="true"
                    :dot-scale="1"
                    :text="codeUrl"
                  /> -->
                  <vue-qr
                    :size="item.scanSize"
                    :margin="0"
                    :auto-color="true"
                    :dot-scale="1"
                    :text="codeUrl"
                    :style="[{marginLeft: `${item.marginLeft}px`},{marginTop: `${item.marginTop}px`}]"
                  />
                </div>
              </div>
              <!--右边-->
              <div class="ewmRightBox">
                <div class="ewmRightBoxTit1">国家标识 一物一码</div>
                <div class="ewmRightBoxTit2">---- 防伪验证 ----</div>

                <div class="myboxWrap">
                  <div class="myBox1" :style="{ color: item.zsxx.xxColor }">
                    <span
                      class="center"
                      :style="{
                        color: item.zsxx.numColor,
                        background: '#F2EDDA',
                      }"
                      >1</span
                    >对比实物标签与图片
                  </div>
                  <div class="myBox2" :style="{ color: item.zsxx.xxColor }">
                    <span
                      class="center"
                      :style="{
                        color: item.zsxx.numColor,
                        background: '#F2EDDA',
                      }"
                      >2</span
                    >观察图片中的文字、位置、编码是否相符
                  </div>
                  <div class="myBox3" :style="{ color: '#675B22' }">
                    以上特征均相符，则是真品，否则谨防假冒
                  </div>
                </div>
              </div>
            </div>
            <div class="style2_msgBox2">
              <div class="rightContent">
                <p class="rightText1">工业互联网标识码：</p>
                <p class="rightText2">{{ handle ? handle : "---" }}</p>
              </div>
            </div>
            <div class="style2_msgBox3">
              由国家工信部授权工业互联网标识解析二级节点（86.122）签发
            </div>
            <div class="style2_msgBox4">
              上次查询时间为：<span class="red">-----</span>
            </div>
            <div class="style2_msgBox5">
              上次查询地点为：<span class="red">-----</span>
            </div>
            <div class="style2_msgBox6">
              <img
                src="https://apkpic.86122m.com/yimai_photos/customPage/template/fdj.png"
              />
              现在是第<span class="red">--</span>次查询
            </div>
            <div class="style2_msgBox7">
              *若查询扫码次数过多，标识码可能被盗用，谨防假冒产品！
            </div>
            <div class="jumpBox" v-if="item.zsxx.jumpStyle == 1">
              <img
                class="jumpButton1"
                src="https://apkpic.86122m.com/custom/8569776c96884d28f9ddaad6767e6c61.png"
              />
            </div>
          </div>
          <!-- 校验码结束 -->
          <div class="imgBox">
            <img :src="item.zsxx.topImg2" class="zsImg1" />
          </div>
          <div class="swiperImg">
            <div class="swiperWrap">
              <div class="swiperName">
                <div class="blackText">第三方权威检测·</div>
                <div class="redText">真实年份验证</div>
              </div>
              <div class="swiperBox">
                <van-swipe
                  :autoplay="2000"
                  indicator-color="transparent"
                  :show-indicators="false"
                  @change="onSwipeChange"
                >
                  <van-swipe-item
                    v-for="(picItem, index) in item.zsxx.picList"
                    :key="picItem.url + index"
                  >
                    <van-image width="78%" :src="picItem.url" class="vanImgs" />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <div class="swipeNum">
                <span class="swipeIndex">{{ activeIndex + 1 }}</span
                >/{{ item.zsxx.picList.length }}
              </div>
            </div>
          </div>
          <div class="imgBox videoWrap">
            <img :src="item.zsxx.bottomImg1" class="zsImg1" />
            <!-- 视频列表 -->
            <div class="videoList">
              <div
                class="videoItem"
                v-for="(it, index) in item.zsxx.videoList"
                :key="index"
              >
                <div class="videoBlock">
                  <img
                    class="playBtn"
                    src="https://apkpic.86122m.com/custom/70e13311754d7ad1f7fbdfe21bc59dd4.png"
                  />
                  <video
                    class="myVideoItem"
                    controls="false"
                    :poster="it.poster"
                    :id="'video' + index"
                    play-btn-position="center"
                    show-play-btn="false"
                    object-fit="cover"
                    :src="it.url"
                  ></video>
                </div>

                <div class="videoDesc">
                  <div class="videoTime">{{ it.time }}</div>
                  <div class="videoDescText">{{ it.desc }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="imgBox">
            <img :src="item.zsxx.bottomImg2" class="zsImg1" />
          </div>
          <div class="imgBox bottomImg3">
            <div class="phoneBox">
              <div class="phoneNum">{{ item.zsxx.phone }}</div>
            </div>
            <img :src="item.zsxx.bottomImg3" class="zsImg1" />
          </div>
        </div>
      </div>

      <div v-show="!showPage" class="photosPage">
        <div class="logoBox">
          <img :src="item.xchy.logo" class="logo" />
        </div>
        <div class="pageTit">{{ item.xchy.title }}</div>
        <div class="newBody">
          <div class="newTitWrap">
            <div class="newTit">
              <div class="newEngTit">{{ item.xchy.infoEng }}</div>
              <div class="newCheTit">{{ item.xchy.infoTit }}</div>
            </div>
          </div>
          <div class="photoWrap newPhotosWrap">
            <video
              class="myVideo"
              controls="false"
              :poster="item.xchy.poster"
              object-fit="contain"
              :src="item.xchy.video"
            ></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Image as VanImage, Swipe, SwipeItem } from "vant";
import VueQr from "vue-qr";
export default {
  data() {
    return {
      selTabbar: null,
      activeIndex: 0,
      showPage: true,
      flodIndex: null, //记录折叠的index

      codeUrl: "",
      veridicalCode: "", // 防伪码
      errTip: false,
      // verState: 0, // 0 未验证 1 验证成功 2 验证失败
      txmDialogVisible: false,
    };
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [VanImage.name]: VanImage,
    VueQr,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    verState: Number,
    handleLink: String,
    handle: String,
    query: {
      type: String,
    },
    h: {
      String,
    },
    codeData: {
      type: Object,
    },
  },
  computed: {
    
    imgStyle(picItem, item) {
      return (n, item) => {
        var wid;
        var pos;
        var str;
        // pos = item.align
        if (n.width) {
          wid = n.width;
        } else {
          wid = "100%";
        }
        str = "width: " + wid;
        if (pos === "left") {
          console.log("pos", pos);
          str = `width: ${wid};float: ${pos}`;
        } else if (pos === "right") {
          console.log("pos", pos);
          str = `width: ${wid};float: ${pos}`;
        } else if (pos === "center") {
          console.log("pos", pos);
          str = `width: ${wid};margin: 0 auto;`;
        }
        return str;
      };
    },
  },
  mounted() {
    this.selTabbar = this.item.tabbar[0];
    this.$emit("fyChangeTab", this.selTabbar);

    this.setCode();
  },
  methods: {
    playVideo(index) {
      const videoElement = document.getElementById("video" + index);
      const playBtn = videoElement.parentElement.querySelector(".playBtn");

      if (videoElement.paused) {
        // 暂停其他所有视频
        document.querySelectorAll(".myVideoItem").forEach((video) => {
          if (video.id !== "video" + index && !video.paused) {
            video.pause();
            video.parentElement.querySelector(".playBtn").style.display =
              "block";
          }
        });
        // 播放当前视频
        videoElement.play();
        playBtn.style.display = "none";
      } else {
        videoElement.pause();
        playBtn.style.display = "block";
      }
    },
    setCode() {
      if (this.handleLink) {
        this.codeUrl = this.handleLink;
      } else {
        this.codeUrl = "https://api.86122m.com/h?h=aaamz";
      }
    },
    // 点击验证
    toVeridical() {
      if (!this.veridicalCode.trim()) {
        this.errTip = true;
        this.$emit("veridicalCode", this.veridicalCode);
      } else {
        this.errTip = false;
        // 调接口
        this.$emit("veridicalCode", this.veridicalCode);
      }
    },
    openTxmDialog() {
      this.txmDialogVisible = true;
    },
    closeTxmDialog() {
      this.txmDialogVisible = false;
    },

    changeTabbar(item) {
      this.showPage = true;
      if (this.flodIndex) {
        let isFlod = this.item.zsxx.infoMain[this.flodIndex].isFold;
        this.item.zsxx.infoMain[this.flodIndex].isFold = !isFlod;
      }
      this.selTabbar = item;
      this.$emit("fyChangeTab", this.selTabbar);
    },
    onSwipeChange(event) {
      let activeIndex = event;
      this.activeIndex = activeIndex;
    },
    morePhotos() {},
    changePage() {
      this.showPage = false;
    },
    changeFlod(index, isFlod) {
      this.flodIndex = index;
      this.item.zsxx.infoMain[index].isFold = !isFlod;
      console.log(
        "----- this.item.zsxx.infoMain[index].isFold-----",
        this.item.zsxx.infoMain[index].isFold
      );
      // this.item.zsxx.infoMain[index].isFold = !this.item.zsxx.infoMain[index].isFold
    },
  },
};
</script>
<style scoped>
.fangyuanPage {
  background: rgba(241, 249, 252, 1);
  position: relative;
  padding-bottom: 91px;
}
.fixedTabbar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 91px;
  background: #f7f9ff;
  /* box-shadow: 0rpx 4rpx 49rpx 0rpx rgba(154,188,230,0.6); */
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.tabbarItem {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #2a3c6c;
  text-emphasis: center;
}

.tabbarItem img {
  height: 22px;
  text-emphasis: center;
  margin-bottom: 6px;
}
.selTabbar {
  color: #0b2977;
  font-weight: bold;
}
.logo {
  width: 96px;
  height: 60px;
  /* margin: 0 auto; */
  margin-left: 37px;
  padding-top: 46px;
  margin-bottom: 23px;
}
.pageTit {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #fff;
  text-align: left;
  padding-bottom: 45px;
  padding-left: 37px;
}
.subTitle {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  padding: 6px 30px;
  background: #53a9a6;
  box-shadow: 0px 3px 4px 0px rgba(4, 0, 0, 0.3);
  border-radius: 13px;
  display: inline-block;
  margin-bottom: 35px;
}
.swipeNum {
  font-size: 14px;
  font-family: DIN;
  font-weight: bold;
  color: #7f849a;
  text-align: center;
  padding: 17px 0 30px;
}
.swipeNum .swipeIndex {
  color: #313f87;
  font-size: 20px;
}
.otitle {
  /* background-image: url('https://apkpic.86122m.com/fangyuanzhengshu/titBg.png'); */
  /* background-repeat: no-repeat;
  background-size: 100% 100%; */
  width: 100%;
  /* height: 80px; */
  text-align: left;
  box-sizing: border-box;
  padding: 30px 30px 33px 30px;
}
.otitleTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.otitleText {
  font-size: 34px;
  color: #fff;
  font-weight: 800;
}
.otitleBot {
  font-size: 12px;
  color: #fff;
}
.infoBody {
  width: 90%;
  margin: 0 auto;
  background: #edf0ff;
  border: 1px solid #ffffff;
  box-shadow: 0px 0px 10px 10px rgba(154, 188, 230, 0.6) inset;
  border-radius: 10px;
  /* padding-bottom: 20px; */
  /* position: relative;
  top: -10px; */
}

.infoItem {
  padding-right: 23px;
  position: relative;
}

.infoItemInner {
  padding-left: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  padding-bottom: 18px;
  text-align: left;
}
.infoItemInner .rkImg {
  width: 156px;
  height: 42px;
  position: absolute;
  right: 23px;
  top: 25px;
}

.infoName {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #2e3033;
  padding-top: 24px;
  padding-bottom: 10px;
  text-align: left;
}

.infoName2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.infoName2 .flodBox {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  display: flex;
  align-items: center;
}
.infoName2 .zkIcon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  transform: rotate(-90deg);
}
.infoName2 .sqIcon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.infoVal {
  text-align: left;
  font-weight: bold;
  font-size: 12px;
}
.green {
  color: #fff;
  background: #13bb76;
  display: inline-block;
  padding: 4px 9px;
  border-radius: 5px;
}
.red {
  color: #fff;
  display: inline-block;
  padding: 4px 9px;
  border-radius: 5px;
}
.yellow {
  background: #daca5e;
  color: #fff;
  display: inline-block;
  padding: 4px 9px;
  border-radius: 5px;
}
.gray {
  background: #ccd1dc;
  color: #fff;
  display: inline-block;
  padding: 4px 9px;
  border-radius: 5px;
}
.siteItemBox {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
  padding-bottom: 15px;
  /* border-bottom: 1px solid rgba(60, 76, 145, 0.1) */
}
.siteItemBox .siteHead {
  text-align: left;
  background: #0833a3;
  border-bottom: 2px solid #ffc24b;
  font-size: 14px;
  font-family: Arial;
  font-weight: bold;
  color: #ffffff;
  padding: 7px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.siteItemBox .siteHead span {
  padding-right: 8px;
}
.siteItemBox .siteHead .flex1 {
  height: 2px;
  flex: 1;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
  position: relative;
}
.siteItemBox .siteHead .flex1:after {
  display: block;
  content: "";
  width: 4px;
  height: 4px;
  background: #fff;
  border-radius: 4px;
  position: absolute;
  right: 0;
}

.siteItem_item {
  padding-top: 12px;
  /* padding-bottom: 12px; */
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
}

.infoItemInner .siteItemBox:last-child {
  border: none;
}

.siteItemItem_name {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #313f87;
  padding: 6px 10px;
  /* background: #D2E5FC; */
  border-radius: 63x;
  margin-right: 12px;
}
.siteItemItem_val {
  flex: 1;
  text-align: left;
  font-size: 12px;
}
.infoItemInner2 {
  display: flex;
}
.infoItemInner2 > div {
  width: 50%;
}
.qyImg {
  width: 90%;
  margin: 0 auto 32px;
  border-radius: 10px;
}
.infoBody_msg {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #242426;
  line-height: 21px;
  text-align: left;
  padding: 30px 12px;
}
.infoBody2 {
  position: relative;
  top: -10px;
}

.infoBodyList {
  top: 0;
  margin-bottom: 10px;
}

/****/
.line {
  position: absolute;
  left: 0px;
  top: 15px;
  z-index: 1;
  width: 110px;
  height: 20px;
  background: linear-gradient(120deg, #87b4ff 0%, #e3efff 100%);
}

.name {
  z-index: 9;
  height: 36px;
  background: #ff9f07;
  border: 2px solid #fff085;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 10px;
  position: relative;
  top: 20px;
  margin: 0 8px;
}

.block {
  width: 8px;
  height: 8px;
  background: #ffffff;
  display: inline-block;
  margin-right: 5px;
}
.lcImg {
  width: 100%;
  margin-top: 25px;
}

.qyTitBox {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #2e3033;
  padding: 14px 32px;
  background: linear-gradient(
    92deg,
    rgba(107, 134, 255, 0.2) 0%,
    rgba(237, 245, 255, 0.2) 100%
  );
  position: relative;
  display: flex;
}
.qyTitBox::after {
  content: "";
  display: block;
  width: 10px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: #3c65e5;
  border-radius: 0px 6px 6px 0px;
}
.dtImg {
  width: 96%;
  margin: 10px 10px 20px;
  display: block;
}
.myVideo {
  width: 100%;
  margin: 25px auto 0px;
  border-radius: 10px;
  overflow: hidden;
}
.myVideoItem {
  width: 240px;
  height: 135px;
}
.photoWrap {
  /* width: 95%;
    margin: 0 auto 20px;
    padding: 15px 10px 5px; */
  /* box-sizing: border-box; */
  /* background: #E3EFFF; */
  /* box-shadow: 0px 4px 49px 0px rgba(154,188,230,0.6); */
  /* border: 1px solid #fff; */
  /* border-radius: 10px; */
  /* position: relative;
    top: -10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start; */
  /*column-count: 2; /* 列数 */
  /*column-gap: 10px; /* 列间距 */

  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;
  position: relative;
  padding-top: 25px;
}
.photoWrap .photoImg {
  /* width: 100%; */
  margin-bottom: 10px;

  /* display: inline-block; */
}
.photoWrap .photoImg:nth-child(1) {
  width: 100%;
}
.photoWrap .photoImg:nth-child(2) {
  width: 120px;
  height: 195px;
}
.photoWrap .photoImg:nth-child(3) {
  width: 160px;
  height: 94px;
  /* width: 348px;
    height: 185px; */
}
.photoWrap .photoImg:nth-child(4) {
  width: 160px;
  height: 94px;
  position: absolute;
  right: 0px;
  bottom: 0px;
  /* width: 350px;
    height: 187px; */
}
.fixedBtn {
}
.fixedBtnImg {
  width: 103px;
  height: 45px;
  position: absolute;
  right: 10px;
  bottom: 180px;
}
.photosPage {
  min-height: 200px;
}
.downImg {
  width: 35px;
  height: 35px;
}
.logoBox {
  text-align: left;
}
.otitleImg {
  width: 40px;
  height: 14px;
}

.pb20 {
  padding-bottom: 20px;
}

.newBody {
  border: 1px solid #fff;
  background: #edf0ff;
  box-shadow: 0px 0px 10px 10px rgba(154, 188, 230, 0.7) inset;
  width: 90%;
  box-sizing: border-box;
  margin: 0 auto 23px;
  border-radius: 10px;
  padding: 35px 20px;
}
.newTitWrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #fff;
  padding-bottom: 23px;
}
.newEngTit {
  font-size: 12px;
  font-family: Arial;
  font-weight: 400;
  color: #707b99;
  padding-bottom: 10px;
  text-align: left;
}
.newCheTit {
  font-size: 23px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  text-align: left;
}
.infoBody_msg2 {
  padding: 25px 12px 0;
}
.newTit {
  flex: 1;
  padding-right: 20px;
}
.numberImg {
  width: 52px;
  height: 43px;
}
.infoBody_msg {
  word-break: break-all;
}

.zsImg1 {
  width: 100%;
}
.swiperImg {
  width: 100%;
  background: url("https://apkpic.86122m.com/custom/7ec91210dd2efc37adbac3eacc466f0f.png")
    no-repeat center center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiperWrap {
  width: 323px;
  height: 441px;
  background: url("https://apkpic.86122m.com/custom/645267219853a5950f274d053b918e77.png")
    no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.swiperName {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 31px;
  padding-bottom: 25px;
  font-family: MaoKenWangFengYaSong;
  font-weight: 400;
  font-size: 18px;
  color: #231815;
}
.blackText {
  color: #231815;
}
.redText {
  color: #d7434a;
}
.swiperBox {
  width: 237px;
  height: 320px;
  background: url("https://apkpic.86122m.com/custom/5e33228eae04424983021ec1569d51ba.png")
    no-repeat center center;
  background-size: 90%;
  padding-top: 17px;
}

.ewmBoxWrap {
  width: 100%;
  padding-top: 35px;
  height: auto;
  font-size: 16px;
  /* background: url('https://86122m.com/addons/ewei_shopv2/plugin/diypage/static/images/lan/backHe.png'); */
  background-size: cover;
  position: relative;
}
.ewmBox {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 20px 0;
}

.ewmRightBox {
  width: 70%;
  height: auto;
  display: border-box;
  /* height: 277px; */
}
.ewmRightBoxTit1 {
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 15px;
  color: #2c2e33;
  line-height: 15px;
}
.ewmRightBoxTit2 {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #675b22;
  line-height: 12px;
  margin-top: 9px;
}
.ewmRightBox input {
  border: 1px solid #838a9b;
  border-radius: 5px;
  display: inline-block;
  width: calc(95% - 60px);
  height: 27px;
  line-height: 27px;
  /* margin: 5px 5px 5px 1px; */
  padding-left: 5px;
  font-size: 0.6rem;
  text-align: left;
  padding-right: 50px;
  display: border-box;
  border-right: none;
}
.ewmRightBox button {
  width: 50px;
  height: 27px;
  text-align: center;
  line-height: 27px;
  font-size: 0.6rem;
  background: #0b667c;
  color: #fff;
  /* margin: 5px 0; */
  border-radius: 5px;
  display: inline-block;
  outline: none;
  border: none;
}
.errTip {
  font-size: 12px;
  color: #f00;
  text-align: left;
  line-height: 20px;
  padding-left: 10px;
}
.verRes {
  font-size: 12px;
  color: #f00;
  text-align: left;
  line-height: 20px;
  padding-left: 10px;
  overflow: hidden;
}
.veridicalTitle {
  font-size: 0.86rem;
  text-align: center;
  position: relative;
  font-weight: 700;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}
.veridicalTitle:before,
.veridicalTitle:after {
  content: "";
  position: absolute;
  top: 50%;
  background: #acacac;
  width: 10%;
  height: 1px;
}
.veridicalTitle:before {
  left: 10%;
}
.veridicalTitle:after {
  right: 10%;
}
.chinaTitle {
  font-size: 1.1rem;
  color: #1f2224;
  text-align: center;
  font-weight: bolder;
  /* margin: 25px 0 0; */
  font-family: cursive;
  line-height: 24px;
}

/**风格一**/
.ewmLeftBox {
  width: 43%;
  margin-left: 2%;
  margin-right: 2%;
  background: url("https://apkpic.86122m.com/yimai_photos/customPage/template/bq2%402x.png");
  background-size: 100% 100%;
  height: 210px;
  min-height: 170px;
  display: border-box;
  margin-top: 20px;
}
.ewmLeftBox .ewmImgBox {
  margin-top: 80px;
}
.topMsg p {
  text-align: left;
  line-height: 30px;
  color: #000;
  padding-left: 15px;
  background-color: #c8d6da;
  width: 96%;
  font-size: 0.66rem;
  margin: 6px auto;
}
.topMsg p span {
  color: #055167;
}
.centerMsg p {
  text-align: left;
  font-size: 0.7rem;
  line-height: 30px;
  padding-left: 10px;
  color: #000;
}
.centerMsg p img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 5px;
}
.centerMsg p span {
  color: #055167;
  font-size: 1rem;
}
.tipsBox {
  margin-top: 10px;
  padding-top: 10px;
  padding-left: 20px;
  background: url("https://86122m.com/addons/ewei_shopv2/plugin/diypage/static/images/lan/bjKuang.png")
    top left no-repeat;
  background-size: 100% 100%;
}
.tipsBox p {
  font-size: 0.66rem;
  color: #fff;
  text-align: left;
  line-height: 30px;
  padding-left: 10px;
}
.tipsBox p img {
  width: 25px;
  height: 25px;
  vertical-align: top;
}
.tipsBox .tipText {
  font-weight: bolder;
}
.qklBox {
  margin-top: 10px;
  background: url("https://86122m.com/addons/ewei_shopv2/plugin/diypage/static/images/lan/bjQkl.png")
    top left no-repeat;
  background-size: 100% 100%;
  padding-left: 20px;
  padding-top: 20px;
}
.qklBox .box1 {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  border-bottom: 1px solid #fff;
  padding-bottom: 10px;
}
.qklBox .box1 img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  vertical-align: top;
}
.qklRightBox .qklMsg1 {
  color: #fff;
  font-size: 0.6rem;
  text-align: left;
}
.qklRightBox .qklMsg2 {
  color: #fff;
  font-weight: 700;
  font-size: 0.6rem;
  text-align: left;
}
.qklBox .box2 {
  font-size: 12px;
  color: #fff;
  line-height: 20px;
  width: 98%;
  padding: 5px 0 10px;
}
/***风格二***/
.ewmLeftBox2 {
  width: 108px;
  height: 108px;
  margin-left: 2%;
  margin-right: 2%;
  background-size: 100% 100%;
  margin-top: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ewmLeftBox2 .yzCode {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}
.ewmLeftBox2 .ewmImgBox2 img {
  width: 60%;
}
.ewmLeftBox .ewmImgBox2 .ewmImgCode2 {
  text-align: center;
  font-size: 12px;
  color: #333;
  line-height: 25px;
}
.style2_msgBox1 {
  font-size: 14px;
  font-weight: 400;
  color: #211f1f;
  text-align: left;
  margin-bottom: 20px;
}
.style2_msgBox1 img {
  width: 40px;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
}
.style2_msgBox1 .tipMsg {
  font-size: 12px;
  font-weight: 500;
  color: #211f1f;
  padding-left: 10px;
}
.style2_msgBox2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;
  border-bottom: 1px dashed #0a566d;
  width: 80%;
  position: relative;
}
.style2_msgBox2 img {
  width: 30px;
  height: 30px;
}
.rightContent {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
}
.style2_msgBox2 .rightContent .rightText1 {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: #3e362c;
  line-height: 20px;
  padding-left: 10px;
  text-align: left;
}
.style2_msgBox2 .rightContent .rightText2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #242326;
  line-height: 20px;
  padding-left: 10px;
  text-align: left;
}
.style2_msgBox3,
.style2_msgBox7 {
  font-size: 12px;
  font-weight: 400;
  color: #b49b51;
  line-height: 20px;
  text-align: left;
  padding-left: 10px;
}
.style2_msgBox7 {
  color: #3e3924;
}
.style2_msgBox4,
.style2_msgBox5 {
  font-size: 12px;
  font-weight: 400;
  color: #3e362c;
  padding: 3px 5px;
  text-align: left;
  background: #fcfcf0;
  width: 70%;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}
.red {
  color: #f00;
}
.style2_msgBox6 {
  font-size: 14px;
  font-weight: 400;
  color: #3e362c;
  text-align: left;
  padding-left: 10px;
}
.style2_msgBox6 img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 5px;
}

.ewmBoxTitle1 {
  font-family: Source Han Serif CN;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  color: #656453;
}
.ewmBoxTitle2 {
  font-family: MaoKenWangFengYaSong;
  font-weight: 400;
  font-size: 30px;
  color: #231815;
  line-height: 30px;
  margin-top: 12px;
}
.myBox1 {
  font-size: 12px;
  color: #211f1f;
  text-align: left;
  vertical-align: middle;
  padding: 5px 0 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.myBox2 {
  font-size: 12px;
  color: #211f1f;
  text-align: left;
  vertical-align: middle;
  padding: 5px 0 0 10px;
}
.myBox1 img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}

.myBox2 img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}
.myBox2 {
  font-size: 12px;
  color: #211f1f;
}
.myBox3 img {
  width: 90%;
}
.myboxWrap {
  border: 1px dashed #cccccc;
  padding: 5px;
  width: 90%;
  margin-top: 15px;
  background: #fcfcf0;
  border-radius: 12px;
}
.myVerBox {
  position: relative;
  /* border: 1px solid #f00; */
  width: 90%;
  padding-left: 5px;
  text-align: left;
}
.myVerBox button {
  position: absolute;
  right: 0;
  top: 1px;
  height: 30px;
  background-color: #5092ff;
}

/**弹窗控件**/
.txmBtn {
  width: 95px;
  height: 112px;
  position: absolute;
  right: 0;
  bottom: 10px;
}
.txmInner {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}
.txmDialog {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.closeImg {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  overflow-y: scroll;
}
.txmInner {
  padding-top: 30px;
}
.txmInner img {
  max-width: 100%;
}
.jumpBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 25px;
}
.jumpButton1 {
  width: 136px;
  height: 42px;
}
.ewmRightBox img {
  width: 80%;
}
.ewmRightBox .img1 {
  margin: 30px 0;
}
.ewmRightBox .img2 {
  margin-bottom: 30px;
}

.myBox1 {
  font-size: 12px;
  /* color: #FFFFFF; */
  text-align: left;
  vertical-align: middle;
  padding: 0px 0 0px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 18px;
}

.myBox2 {
  font-size: 12px;
  /* color: #FFFFFF; */
  text-align: left;
  vertical-align: middle;
  padding: 0px 0 0px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 18px;
}

.myBox3 {
  font-size: 12px;
  /* color: #FFFFFF; */
  text-align: left;
  vertical-align: middle;
  padding: 0px 0 10px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 500;
  line-height: 18px;
}

.myBox1 span,
.myBox2 span {
  width: 20px;
  height: 20px;
  font-size: 18px;
  color: #d9eace;
  margin-right: 5px;
  line-height: 18px;
  font-weight: 500;
  vertical-align: middle;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.videoWrap {
  position: relative;
}
.videoList {
  position: absolute;
  top: 170px;
  z-index: 3;
  margin-left: 42px;
}
.videoItem {
  border-left: 1px dashed #d7434a;
  padding-left: 37px;
  position: relative;
}
.videoItem::before {
  content: " ";
  position: absolute;
  left: -5px;
  top: 0;
  width: 5px;
  height: 5px;
  background-color: #d7434a;
  border-radius: 50%;
  border: 3px solid #fff;
}
.videoBlock {
  overflow: hidden;
  border-radius: 15px;
  position: relative;
}

.playBtn {
  width: 35px;
  height: 35px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.videoDesc {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: MaoKenWangFengYaSong;
  font-weight: 400;
  font-size: 17px;
  padding-top: 21px;
  padding-bottom: 17px;
}
.videoTime {
  color: #B72229;
}
.videoDescText {
  color: #231815;
}
.bottomImg3 {
  position: relative;
}
.bottomImg3 .phoneBox {
  position: absolute;
  bottom: 46px;
  left: 127px;
  color: #d7434a;
  font-size: 12px;
}
</style>
